import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import barChart from 'assets/img/illustrations/crm-bar-chart.png';
import lineChart from 'assets/img/illustrations/crm-line-chart.png';
import Flex from '../../../../components/common/Flex';

const Greetings = (


) => {

    return (
        <Card className="mb-1 p-2">
            <Row className="g-0 justify-content-between">
                <Col sm="auto">
                    <Flex alignItems="center">
                        <img src={barChart} width={90} alt="..." className="ms-n4" />
                        <div>
                            <h4 className="text-primary fw-bold mb-0">

                                <span className="text-primary fw-medium"> Activos Fijos</span>
                            </h4>
                        </div>
                        <img
                            src={lineChart}
                            width={140}
                            alt="..."
                            className="ms-n4 d-md-none d-lg-block"
                        />
                    </Flex>
                </Col>
                
            </Row>
        </Card>
    );
};


export default Greetings;
